import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { PistaLiveSnapshot, PistaLiveWatchOptions } from '../models/moderacion/pista-live.dto';

export interface PistaLiveTransport {
  watch(exposicionId: number, options?: PistaLiveWatchOptions): Observable<PistaLiveSnapshot>;
}

export const PISTA_LIVE_TRANSPORT = new InjectionToken<PistaLiveTransport>('PISTA_LIVE_TRANSPORT');
